import './model-single-diensten.scss';

/**
 * Eén gedeeld <dialog> per sectie: vult titel, body en optionele koppel-URL via JSON op de trigger.
 *
 * @param {HTMLElement} section Wortel .js-modelSingleDiensten
 */
const initDienstenDialog = ( section ) => {
	const id = section.getAttribute( 'data-diensten-dialog-id' );
	if ( ! id ) {
		return;
	}

	const dialog = document.getElementById( id );
	if ( ! dialog || ! ( dialog instanceof HTMLDialogElement ) ) {
		return;
	}

	const moreLabel = section.getAttribute( 'data-diensten-more-label' ) || 'Meer informatie';
	const elTitle  = dialog.querySelector( '.b-modelSingle__dienstenDialogTitle' );
	const elBody   = dialog.querySelector( '.b-modelSingle__dienstenDialogBody' );
	const elMore   = dialog.querySelector( '.b-modelSingle__dienstenDialogMore' );
	const elMoreA  = dialog.querySelector( '.b-modelSingle__dienstenDialogMoreLink' );
	const btnClose = dialog.querySelector( '.b-modelSingle__dienstenDialogClose' );

	const applyPayload = ( raw ) => {
		if ( ! raw ) {
			return false;
		}
		let data;
		try {
			data = JSON.parse( raw );
		} catch ( _e ) {
			return false;
		}
		const body = typeof data.body === 'string' ? data.body.trim() : '';
		if ( ! body ) {
			return false;
		}
		if ( elTitle ) {
			elTitle.textContent = typeof data.title === 'string' ? data.title : '';
		}
		if ( elBody ) {
			elBody.textContent = typeof data.body === 'string' ? data.body : '';
		}
		if ( elMore && elMoreA ) {
			const u = typeof data.moreUrl === 'string' ? data.moreUrl.trim() : '';
			if ( u ) {
				elMoreA.setAttribute( 'href', u );
				elMoreA.textContent = moreLabel;
				elMore.hidden = false;
			} else {
				elMoreA.removeAttribute( 'href' );
				elMoreA.textContent = '';
				elMore.hidden = true;
			}
		}
		return true;
	};

	section.querySelectorAll( '.b-modelSingle__dienstenInfo--popup' ).forEach( ( btn ) => {
		if ( ! ( btn instanceof HTMLButtonElement ) ) {
			return;
		}
		btn.addEventListener( 'click', () => {
			const raw = btn.getAttribute( 'data-diensten-payload' );
			if ( ! applyPayload( raw ) ) {
				return;
			}
			if ( ! dialog.open ) {
				dialog.showModal();
			}
		} );
	} );

	if ( btnClose ) {
		btnClose.addEventListener( 'click', () => {
			if ( dialog.open ) {
				dialog.close();
			}
		} );
	}

	dialog.addEventListener( 'click', ( e ) => {
		if ( e.target === dialog && dialog.open ) {
			dialog.close();
		}
	} );

	dialog.addEventListener( 'cancel', ( e ) => {
		e.preventDefault();
		if ( dialog.open ) {
			dialog.close();
		}
	} );
};

const initDienstenTableToggle = ( root ) => {
	if ( ! root || root.dataset.modelSingleDienstenTableInit === '1' ) {
		return;
	}

	const button = root.querySelector( '.js-modelSingleDienstenTableToggle' );
	const hiddenRows = Array.from( root.querySelectorAll( '.b-modelSingle__dienstenRij--hidden' ) );
	if ( ! button || hiddenRows.length === 0 ) {
		return;
	}

	root.dataset.modelSingleDienstenTableInit = '1';

	const showLabel = button.getAttribute( 'data-show-label' ) || 'Show more';
	const hideLabel = button.getAttribute( 'data-hide-label' ) || 'Show less';
	let expanded = false;

	const render = () => {
		hiddenRows.forEach( ( row ) => {
			row.style.display = expanded ? 'table-row' : 'none';
		} );
		button.textContent = expanded ? hideLabel : showLabel;
		button.setAttribute( 'aria-expanded', expanded ? 'true' : 'false' );
	};

	button.addEventListener( 'click', () => {
		expanded = ! expanded;
		render();
	} );

	render();
};

document.querySelectorAll( '.js-modelSingleDiensten' ).forEach( ( el ) => {
	initDienstenDialog( el );
} );

document.querySelectorAll( '.js-modelSingleDienstenTable' ).forEach( ( el ) => {
	if ( ! ( el instanceof HTMLElement ) ) {
		return;
	}
	initDienstenTableToggle( el );
} );
